import { UIComponent } from '@/components/core/components';
import { Trans } from '@lingui/react/macro';
import { useLingui } from '@lingui/react';
import * as styles from './rating.styles';

const Rating: UIComponent<{ rating: { value: number; total: number } }> = ({ children, rating }) => {
  const { i18n } = useLingui();
  const totalFormatter = new Intl.NumberFormat(i18n.locale, { notation: 'compact' });
  return (
    <div className={styles.root}>
      <div>
        <Trans>
          <span className={styles.value}>{totalFormatter.format(rating.value)}</span> of 5
        </Trans>
      </div>
      <div className={styles.total}>
        <Trans>{totalFormatter.format(rating.total)} reviews</Trans>
      </div>
      {children}
    </div>
  );
};
export default Rating;
